var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { attrs: { align: "center" } },
    [
      _c(
        "v-col",
        { attrs: { cols: "6" } },
        [
          _c("v-select", {
            staticClass: "ml-2",
            attrs: {
              outlined: "",
              dense: "",
              "hide-details": "",
              "item-text": "title",
              "item-value": "value",
              items: _vm.$options.datesTypesEnums,
              value: _vm.getDateTypeValue,
            },
            on: {
              change: function ($event) {
                return _vm.updateDateType($event)
              },
            },
          }),
        ],
        1
      ),
      _vm.isValidValue
        ? _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "v-menu",
                {
                  ref: "menuDate",
                  attrs: {
                    "close-on-content-click": false,
                    "return-value": _vm.value,
                    transition: "scale-transition",
                    "offset-y": "",
                    "min-width": "auto",
                  },
                  on: {
                    "update:returnValue": function ($event) {
                      _vm.value = $event
                    },
                    "update:return-value": function ($event) {
                      _vm.value = $event
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "v-text-field",
                              _vm._g(
                                _vm._b(
                                  {
                                    attrs: {
                                      outlined: "",
                                      "append-icon": "mdi-calendar",
                                      readonly: "",
                                      "hide-details": "",
                                      dense: "",
                                      value: _vm.preparedFormatTime,
                                    },
                                    on: { change: _vm.returnValue },
                                  },
                                  "v-text-field",
                                  attrs,
                                  false
                                ),
                                on
                              )
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    33345946
                  ),
                },
                [
                  _c(
                    "v-date-picker",
                    {
                      attrs: {
                        "no-title": "",
                        scrollable: "",
                        value: _vm.value,
                      },
                      on: { change: _vm.returnValue },
                    },
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", color: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.$refs.menuDate.save(_vm.value)
                            },
                          },
                        },
                        [_vm._v(" OK ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }